// extracted by mini-css-extract-plugin
export var buttonContainer = "_9j-1";
export var fontSizeSelect = "_9j-3";
export var formatSelect = "_9j-2";
export var formats = "_9j-4";
export var hidden = "_9j-5";
export var icon = "_9j-6";
export var select = "_9j-0";